/// <reference path="../index.d.ts"/>

import * as React from "react";
import { Select as AntdSelect } from "antd";
const AntdOption = AntdSelect.Option;

// select type on antd is missing onBlur type
// workaround
const AntdSelectAny = require("antd/lib/select");

class Select extends React.Component<any, any> {
  constructor() {
    super();
    this.state = { fieldValue: "", value: [] };
  }

  renderOptions() {
    const { options } = this.props;

    if (options && options.length > 0) {
      return options.map((option: IOptionFieldProps) => (
        <AntdOption key={option.value} value={option.value}>
          {option.label}
        </AntdOption>
      ));
    } else {
      return this.props.children;
    }
  }

  handleInputChange(target: string, value: string) {
    this.setState({ fieldValue: value });
  }

  handleBlur(value: any) {
    if (this.state.fieldValue.trim().length > 0) {
      this.setState(prevState => ({ fieldValue: "", value: [...prevState.value, prevState.fieldValue] }));
      let valueState = [...this.state.value, this.state.fieldValue];
      let event = {
        target: {
          name: this.props.name,
          value: valueState
        }
      };
      this.props.handleChange(event);
      if (this.props.form) {
        this.props.form.setFieldsValue({
          [this.props.form_value_key]: valueState
        });
      }
    }
  }

  handleChange(target: string, value: string) {
    let validChange = value.length == 0 || value[value.length - 1].length > 0

    if (validChange) {
      // hack, build event object to standardize parameters
      let event = {
        target: {
          name: target,
          value: value
        }
      };

      this.props.handleChange(event);
      this.setState({ fieldValue: "", value: value });
      if (this.props.form) {
        this.props.form.setFieldsValue({ [this.props.form_value_key]: value });
      }
    }
  }

  componentWillMount() {
    if ("value" in this.props) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    const {
      placeholder,
      mode,
      className,
      value,
      name,
      disabled,
      tokenSeparators
    } = this.props;

    return (
      <AntdSelectAny
        mode={mode}
        value={value}
        choiceTransitionName={null}
        placeholder={placeholder}
        tokenSeparators={tokenSeparators}
        className={className}
        disabled={disabled}
        onSearch={this.handleInputChange.bind(this, name)}
        onBlur={this.handleBlur.bind(this)}
        onChange={this.handleChange.bind(this, name)}
        dropdownStyle={mode === "tags" ? { display: "none" } : {}}
      >
        {this.renderOptions()}
      </AntdSelectAny>
    );
  }
}

interface IOptionFieldProps {
  value: any;
  label: string;
  disabled?: boolean;
}

interface ISelectFieldProps extends IGenericFieldProps {
  mode?: "multiple" | "tags" | "combobox";
  value: string[] | string;
  options: Array<IOptionFieldProps>;
  handleChange: (e: any) => void;
  disabled: boolean;
  name: string;
  tokenSeparators?: string[];
  placeholder?: string;
  form?: any;
  form_value_key?: string;
}

export default Select;



// WEBPACK FOOTER //
// ./client/modules/form/Select/index.tsx